/* The same table as the gallery's list view (`.card.table-wrap` + `.table`). */
.wrap {
  overflow-x: auto;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  text-align: start;
  white-space: nowrap;
}

.table td {
  block-size: 48px;
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  vertical-align: middle;
}

.table tbody tr:last-child td {
  border-block-end: 0;
}

.table tbody tr:hover {
  background: var(--surface-sunken);
}

.name {
  color: var(--text);
  font-weight: var(--font-weight-medium);
}

.date {
  color: var(--text-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.actionsHead,
.actions {
  text-align: end;
  white-space: nowrap;
}

/* "Borrar definitivamente" is the mockup's `.btn-ghost.btn-danger`: a ghost button in the danger text colour. */
.danger {
  color: var(--danger-text);
}

/* The actions column has no visible heading (the mockup's `.sr-only`), but keeps its name. */
.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
